import { useOnboardingStore } from '../stores/onboardingStore'

import { registerSessionReset } from '@/features/auth'

/** Session teardown only — deliberately NO workspace watch. The onboarding wizard is what
 *  *causes* the workspace switch: `CreateWorkspaceFlow` calls `setCreatedWorkspace(id)` and then
 *  selects that new workspace, so a `flush: 'sync'` watch would wipe the wizard's own
 *  `defaults`/`createdWorkspaceId`/`furthestStep` between step 1 and step 2. A logout closes the
 *  takeover outright — its open flag and the tab's resume record included — so the next user never
 *  inherits another's run or brand-context defaults. */
export function registerGlobalSurfaceLifecycle(): () => void {
  const store = useOnboardingStore()
  return registerSessionReset(() => store.close())
}
